import { Container } from './style';

export function TransversalBar() {
    return <Container/>
}
